import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage, {FORM_STATE_INIT_ERROR} from '../../components/plain/PlainPage';
import LabelField from '../../components/plain/LabelField';
import FieldString from '../../components/plain/FieldString';
import FieldInteger from '../../components/plain/FieldInteger';
import FieldDecimal from '../../components/plain/FieldDecimal';
import FieldDatetime from '../../components/plain/FieldDatetime';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldReference from '../../components/plain/FieldReference';
import FieldList_TableEntity from '../../components/plain/FieldList_TableEntity';
import MReportItemPlainModal from './MReportItemPlainModal';

import {getCurrentResource, formatDateTime} from '../../util/tools';
import {isSuperUser} from '../../util/localStorage';
import {
	performApiRequest, ACTION_EBOOK_REPORT_GET_SUPPLIER_API_URL, ENTITY_LOAD_API_URL,
	ACTION_MREPORT_ITEM_DELETE_API_URL,
} from '../../util/restapi'; 

import {CLASS_MREPORT, CLASS_EBOOK_SUPPLIER} from '../../util/consts/classes';
import {FORM_MREPORT_PLAIN, FORM_EBOOK_SUPPLIER_TABLE, FORM_MREPORT_ITEM_ENTITY_T} from '../../util/consts/forms';
import {EBOOK_SUPPLIER_PLAIN_PATH} from '../../util/routes';


class MReportPlainPage extends PlainPage {

	refSupplierNodes = [
		{
			classId: CLASS_EBOOK_SUPPLIER, plainFormPath: EBOOK_SUPPLIER_PLAIN_PATH, 
			selectInstanceFormId: FORM_EBOOK_SUPPLIER_TABLE,
			selectInstanceFormTitle: 'Розповсюджувач'
		}
	];
	
	readOnly = false;
	
	constructor(props) {
		super(props);
//		this.plainId = FORM_MREPORT_PLAIN;
		this.formPath = FORM_MREPORT_PLAIN;
		this.formTitle = 'Звіт моніторинга';
		this.refItemsTable = React.createRef();
		this.refDeleteItemsModal = React.createRef();
		this.refQty = React.createRef();
		this.refTotal = React.createRef();
		this.resourceReportPage = getCurrentResource().pages.plain.MReportPlainPage;
	}
	componentDidMount = async () => {
		this.init( CLASS_MREPORT );
		document.title = 'BOM. ' + this.formTitle;
	}
	completeInit = async () => {
//		if( this.instance ) {
//			let state = this.instance.rootField.value.state.value;
//			if( state == 'accepted' && ! isSuperUser() )
//				this.readOnly = true;
//		}
		let beanSupplier = null;
		if( this.instance.id == null ) {
			this.instance.rootField.value.dateTime.value = formatDateTime( new Date() );
			let supplierRequest = {
				type: 'initial'
			}
			let response = await performApiRequest(ACTION_EBOOK_REPORT_GET_SUPPLIER_API_URL, supplierRequest);
			if( ! response.success ) {
				this.setState({formState: FORM_STATE_INIT_ERROR, message: response.message});
				return false;
			}
			beanSupplier = response.data;
			if( beanSupplier != null ) {
				let refSupplier = {
					id: beanSupplier.id,
					globalId: beanSupplier.globalId,
					className: beanSupplier.className,
					card: beanSupplier.cardMaster
				};
				this.instance.rootField.value.supplierRef.value = refSupplier;
			} 
		} else {
			let supplierRef = this.instance.rootField.value.supplierRef.value;
			if( supplierRef != null ) {
				let response = await performApiRequest(ENTITY_LOAD_API_URL, {id: supplierRef.id});
				if( ! response.success ) {
					this.setState({formState: FORM_STATE_INIT_ERROR, message: response.message});
					return false;
				}
				beanSupplier = response.data.entity;
			}
		}
		this.state.supplier = beanSupplier;
		this.state.isSupplierRefReadOnly = this.instance.rootField.value.reportItems.value.length > 0;
		return true;
	}

	createReportItemPlain = (table, index, bean) => {
		return (
			<MReportItemPlainModal table={table} bean={bean} indexBean={index} masterPlain={this}/>
		)
	}
	deleteReportItems = async (listIdForDelete) => {
		let deleteItemsRequest = {
			listId: listIdForDelete
		}
		let response = await performApiRequest(ACTION_MREPORT_ITEM_DELETE_API_URL, deleteItemsRequest);
		if( response.success ) {
			this.instance.setFieldValueByPath('/qty', response.reportQty);
			this.instance.setFieldValueByPath('/total', response.reportAmount);
		}
		return response;
	}	
	
	renderBody() {
		let res = this.resourceReportPage;
		let instance = this.state.instance;
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FieldReference instance={instance} path={'/supplierRef'} plain={this}
							refNodes={this.refSupplierNodes}
							readOnly={this.state.isSupplierRefReadOnly || this.readOnly}
							styles={{divMain: {flexGrow: '1'}}}
						/>
					</div>
					<div style={{ display: 'flex', marginTop: '15px',alignItems: 'center'}}>
						<FieldDatetime instance={instance} path={'/dateTime'} plain={this} 
							readOnly={this.readOnly}
							styleInput={{width: '200px', marginRight: '20px'}} 
						/>
						<FieldEnum instance={instance} path={'/year'} plain={this} 
							readOnly={this.readOnly}
							styles={{ select: {flexGrow: '1', marginRight: '20px'}}}
						/>
						<FieldEnum instance={instance} path={'/month'} plain={this} 
							readOnly={this.readOnly}
							styles={{ select: {flexGrow: '1', marginRight: '20px'}}}
						/>
						<FieldInteger ref={this.refQty} instance={instance} path={'/qty'} plain={this} 
							readOnly={true}
							styleInput={{width: '60px', textAlign: 'right', marginRight: '20px'}} 
						/>
						<FieldDecimal ref={this.refTotal} instance={instance} path={'/total'} plain={this} 
							readOnly={true}
							styleInput={{width: '100px', textAlign: 'right', marginRight: '20px'}} 
						/>
						<FieldEnum instance={instance} path={'/state'} plain={this} 
							readOnly={ ! isSuperUser() }
							styles={{ select: {flexGrow: '1'}}}
						/>
					</div>
					<div style={{marginTop: '20px'}}>
						<FieldList_TableEntity ref={this.refItemsTable}
							formId={FORM_MREPORT_ITEM_ENTITY_T} 
							instance={instance}
							readOnly={this.readOnly}
							table={{
								columns: [
									{ columnId: 'dateTime', styles: {tdHeader: {width: '17%'} } }, 
									{ columnId: 'ps', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'aid', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'mid', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'mcc', styles: {tdHeader: {width: '7%'} } },
									{ columnId: 'tid', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'bin', styles: {tdHeader: {width: '12%'} } },
									{ columnId: 'operation', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'tranId', styles: {tdHeader: {width: '8%'} } },
									{ columnId: 'qty', styles: {tdHeader: {width: '2%'}, dataComponent: { textAlign: 'right'} } },  
									{ columnId: 'amount', styles: {tdHeader: {width: '4%'}, dataComponent: { textAlign: 'right'} } },
								],
							}}
							deleteMarkedRows={this.deleteReportItems}
							modal={{
								title: res.modalTitle,
								createModalForm: this.createReportItemPlain,
							}}
						/>
					</div>					
					<div style={{marginTop: '20px', paddingRight: '9px'}}>
						<div>
							<LabelField instance={this.state.instance} path={'/comment'} />
						</div>
						<div>
							<FieldString instance={this.state.instance} path={'/comment'} plain={this}
								multiline={true} rows={5} cols={60} styles={{input: {width: '100%'}}}
								readOnly={this.readOnly}
							 />
						</div>
					</div>			
				</div>
			</div>
		);
	}
}

export default MReportPlainPage;